// When accessing routes that don't exist
<template>
  <div>
    <h1>Page not found</h1>
  </div>
</template>
